'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dPage$0024 from "./presto.-Agent-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002441 from "./presto.-Presto-Router$$anon$41.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$40() {
  this.bhe = null;
  this.bh6 = null;
  this.bh7 = false;
  this.bhf = null;
  this.bhg = false;
  this.bhj = null;
  this.bhc = null;
  this.bhd = false;
  this.bh8 = null;
  this.bh9 = false;
  this.bha = null;
  this.bhb = false;
  this.bhh = false;
  this.bhi = false;
  this.bhe = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bhj = "AgentPage";
}
export { $c_Lpresto_PrestoRouter$$anon$40 as $c_Lpresto_PrestoRouter$$anon$40 };
$p = $c_Lpresto_PrestoRouter$$anon$40.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$40;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$40() {
}
export { $h_Lpresto_PrestoRouter$$anon$40 as $h_Lpresto_PrestoRouter$$anon$40 };
$h_Lpresto_PrestoRouter$$anon$40.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bhe;
});
$p.M = (function() {
  if ((!this.bh7)) {
    this.bh6 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bh7 = true;
  }
  return this.bh6;
});
$p.O = (function() {
  if ((!this.bhg)) {
    this.bhf = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bhg = true;
  }
  return this.bhf;
});
$p.E = (function() {
  return this.bhj;
});
$p.t = (function() {
  if ((!this.bhd)) {
    this.bhc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bhd = true;
  }
  return this.bhc;
});
$p.N = (function() {
  if ((!this.bh9)) {
    this.bh8 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bh9 = true;
  }
  return this.bh8;
});
$p.Q = (function() {
  if ((!this.bhb)) {
    this.bha = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002441.$c_Lpresto_PrestoRouter$$anon$41();
    this.bhb = true;
  }
  return this.bha;
});
$p.v = (function() {
  if ((!this.bhi)) {
    this.bhh = false;
    this.bhi = true;
  }
  return this.bhh;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee356) => ((p) => \u03b4scrutinee356))($j_presto$002e$002dAgent$002dPage$0024.$m_Lpresto_AgentPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$40 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$40, "presto.PrestoRouter$$anon$40", ({
  Og: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$40 as $d_Lpresto_PrestoRouter$$anon$40 };
//# sourceMappingURL=presto.-Presto-Router$$anon$40.js.map
